import { useCallback, useMemo, useReducer, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import Reducer from './context/reducer';
import Context from './context/context';

import router from './router';
import './App.css';

const initialState = {
  filteredReviews: [],
  filteredEstablishments: [],
  activeSubCategories: [],
  noPlatformFilteredReviews: [],
  noPlatformFilteredEstablishments: [],
  selectedPlatform: null,
  selectedCategory: null,
  selectedSubCategory: [],
  selectedDates: [],
  selectedSentiment: null,
  selectedAspect: [],
  selectedRegion: [],
  selectedYear: String(new Date().getFullYear() - 1),
  fetchingData: false,
  hasError: false,
};

function App() {
  const [state, dispatch] = useReducer(Reducer, initialState);
  const [establishmentTypes, setEstablishmentTypes] = useState([]);

  const updateFilteredEstablishments = useCallback((payload) => {
    dispatch({ type: 'UPDATE_FILTERED_ESTABLISHMENTS', payload });
  }, []);

  const updateFilteredReviews = useCallback((payload) => {
    dispatch({ type: 'UPDATE_FILTERED_REVIEWS', payload });
  }, []);

  const updateActiveSubCategories = useCallback((payload) => {
    dispatch({ type: 'UPDATE_ACTIVE_SUB_CATEGORIES', payload });
  }, []);

  const updateSelectedCategory = useCallback((payload) => {
    dispatch({ type: 'UPDATE_SELECTED_CATEGORY', payload });
  }, []);

  const updateSelectedSubCategory = useCallback((payload) => {
    dispatch({ type: 'UPDATE_SELECTED_SUB_CATEGORY', payload });
  }, []);

  const updateSelectedDates = useCallback((payload) => {
    dispatch({ type: 'UPDATE_SELECTED_DATES', payload });
  }, []);

  const updateSelectedSentiment = useCallback((payload) => {
    dispatch({ type: 'UPDATE_SELECTED_SENTIMENT', payload });
  }, []);

  const updateSelectedAspect = useCallback((payload) => {
    dispatch({ type: 'UPDATE_SELECTED_ASPECT', payload });
  }, []);

  const updateSelectedRegion = useCallback((payload) => {
    dispatch({ type: 'UPDATE_SELECTED_REGION', payload });
  }, []);

  const updateNoPlatformFilteredReviews = useCallback((payload) => {
    dispatch({ type: 'UPDATE_NO_PLATFORM_FILTERED_REVIEWS', payload });
  }, []);

  const updateNoPlatformFilteredEstablishments = useCallback((payload) => {
    dispatch({ type: 'UPDATE_NO_PLATFORM_FILTERED_ESTABLISHMENTS', payload });
  }, []);

  const updateSelectedPlatform = useCallback((payload) => {
    dispatch({ type: 'UPDATE_SELECTED_PLATFORM', payload });
  }, []);

  const updateSelectedYear = useCallback((payload) => {
    dispatch({ type: 'UPDATE_SELECTED_YEAR', payload });
  }, []);

  const updateFetchingData = useCallback((payload) => {
    dispatch({ type: 'UPDATE_FETCHING_DATA', payload });
  }, []);

  const updateHasError = useCallback((payload) => {
    dispatch({ type: 'UPDATE_HAS_ERROR', payload });
  }, []);

  const value = useMemo(
    () => ({
      ...state,
      updateSelectedPlatform,
      updateSelectedCategory,
      updateSelectedSubCategory,
      updateSelectedDates,
      updateSelectedSentiment,
      updateSelectedAspect,
      updateSelectedRegion,
      updateFilteredReviews,
      updateFilteredEstablishments,
      updateNoPlatformFilteredReviews,
      updateNoPlatformFilteredEstablishments,
      updateActiveSubCategories,
      updateSelectedYear,
      updateFetchingData,
      establishmentTypes,
      setEstablishmentTypes,
      updateHasError,
    }),
    [
      state,
      establishmentTypes,
      updateSelectedPlatform,
      updateSelectedCategory,
      updateSelectedSubCategory,
      updateSelectedDates,
      updateSelectedSentiment,
      updateSelectedAspect,
      updateSelectedRegion,
      updateFilteredReviews,
      updateFilteredEstablishments,
      updateNoPlatformFilteredReviews,
      updateNoPlatformFilteredEstablishments,
      updateActiveSubCategories,
      updateSelectedYear,
      updateFetchingData,
      updateHasError,
    ]
  );

  return (
    <Context.Provider value={value}>
      <RouterProvider router={router} />
    </Context.Provider>
  );
}

export default App;
